import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  IconButton
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { isMobile } from 'react-device-detect'
import moment from 'moment-timezone'
import firebase from '../../store/firebase'
import { IS_COMPANY_ADMIN } from '../../store/actions/types'

const styles = () => ({
  root: {
    padding: 16,
    marginTop: 12
  },
  controls: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    marginBottom: 16
  },
  table: {
    marginTop: 8
  },
  subcell: {
    color: '#555',
    fontSize: 12
  },
  // Mobile cards
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    background: '#fff'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 8
  },
  userName: {
    fontWeight: 600,
    fontSize: 14
  },
  userId: {
    fontSize: 12,
    color: '#666'
  },
  totalLc: {
    fontWeight: 700,
    fontSize: 14
  },
  pagerMobile: {
    position: 'sticky',
    bottom: 12,
    zIndex: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16
  },
  pagerBtn: {
    minWidth: 32,
    padding: '2px 6px'
  },
  // Hide native picker icon on mobile so we don't show two calendars
  mobileDateInput: {
    '&::-webkit-calendar-picker-indicator': {
      display: 'none'
    }
  }
})

//const getTodaySAST = () => moment().tz('Africa/Johannesburg').format('YYYY-MM-DD')
const getTodaySAST = () => moment().tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm'); 

class LcEarningsMonitor extends React.Component {
  state = {
    date: getTodaySAST(), // default to today (single-day view by default)
    dateTo: '',
    loading: false,
    rows: [],
    query: '',
    page: 0,
    pageSize: 10,
    expanded: {}
  }

  // Track last successful query to avoid redundant Firebase reads
  lastQueryKey = ''

  dateInput = React.createRef()
  dateToInput = React.createRef()

  // Safely extract a numeric value from pointsAdded, which may be a number or a string like "0.05 Lc"
  parsePoints = (value) => {
    if (typeof value === 'number') return value
    if (typeof value === 'string') {
      const match = value.match(/[-+]?\d*\.?\d+/)
      return match ? parseFloat(match[0]) : 0
    }
    return 0
  }

  // Prefer dedicated MEV amount fields when backend provides them, fall back to points
  getMevQuantity = (item, fallbackPoints) => {
    // New backend-friendly field name
    if (typeof item.mevAmount === 'number' && isFinite(item.mevAmount)) {
      return Math.abs(item.mevAmount)
    }
    // Backwards‑compat: if future fields are added, they can be handled here
    if (typeof item.amountOfCoinsPurchased === 'number' && isFinite(item.amountOfCoinsPurchased)) {
      return Math.abs(item.amountOfCoinsPurchased)
    }
    if (typeof item.amountOfCoinsSold === 'number' && isFinite(item.amountOfCoinsSold)) {
      return Math.abs(item.amountOfCoinsSold)
    }
    // Legacy behavior: derive from pointsAdded
    return Math.abs(fallbackPoints || 0)
  }

  componentDidMount() {
    this.loadData()
  }

  // classify action labels into buckets we care about
  classify = (label = '') => {
    const s = String(label || '').toLowerCase()
    if (s.includes('mev bought')) return 'mevBought'
    if (s.includes('mev sold')) return 'mevSold'
    if (s.includes('lc sent')) return 'lcSent'
    // Earning actions we want in totals
    if (
      s.includes('like given') ||
      s.includes('like received') ||
      s.includes('comment given') ||
      s.includes('comment received') ||
      s.includes('test passed') ||
      s.includes('test published') ||
      s.includes('ai test published') ||
      s.includes('forum test published') ||
      s.includes('postlead added') ||
      s.includes('postinternal added')
    ) {
      return 'earnLc'
    }
    return 'other'
  }

  // loadData = async () => {
  //   const day = (this.state.date || '').trim()
  //   const dayTo = (this.state.dateTo || '').trim()
  //   const queryKey = `${day || ''}|${dayTo || ''}`

  //   // If we already loaded this exact range and we're not in a loading state,
  //   // skip hitting Firebase again. This protects against rapid double-clicks
  //   // and unnecessary refresh spam on the same filter.
  //   if (this.lastQueryKey === queryKey && !this.state.loading && this.state.rows.length) {
  //     return
  //   }

  //   this.lastQueryKey = queryKey

  //   this.setState({ loading: true })
  //   try {
  //     const db = firebase.database
  //     let snap
  //     if (day && dayTo) {
  //       const start = `${day} 00:00`
  //       const end = `${dayTo} 23:59`
  //       // Range query across multiple dates
  //       snap = await db
  //         .ref('pointsTrail')
  //         .orderByChild('fdate')
  //         .startAt(start)
  //         .endAt(end)
  //         .limitToFirst(2000) 
  //         .once('value')
  //     } else if (day) {
  //       const start = `${day} 00:00`
  //       const end = `${day} 23:59`
  //       // Date-filtered query (prefer indexOn: ["fdate"] for performance)
  //       snap = await db
  //         .ref('pointsTrail')
  //         .orderByChild('fdate')
  //         .startAt(start)
  //         .endAt(end)
  //         .limitToFirst(2000) 
  //         .once('value')
  //     } else {
  //       // No date selected → show recent entries (cap for safety)
  //       snap = await db.ref('pointsTrail').limitToLast(5000).once('value')
  //     }
      
  //     const items = []
  //     if (snap.exists()) {
  //       snap.forEach((child) => {
  //         items.push(child.val())
  //       })
  //     }

  //     // Keep all; we'll aggregate by buckets
  //     const dayItems = items

  //     const userMap = new Map()
  //     dayItems.forEach((it) => {
  //       const userID = String(it.userID || '')
  //       const key = userID
  //       if (!key) return
  //       const fullName = [it.firstName, it.lastName].filter(Boolean).join(' ').trim() || it.firstName || ''
  //       const action = String(it.actionType || 'Unknown')
  //       const points = this.parsePoints(it.pointsAdded)
  //       const mevQty = this.getMevQuantity(it, points) // quantity of MEV coins when action is MEV buy/sold
  //       if (!userMap.has(key)) {
  //         userMap.set(key, {
  //           userID,
  //           fullName,
  //           totalLc: 0,
  //           actions: {},
  //           mevBought: 0,
  //           mevSold: 0
  //         })
  //       }
  //       const row = userMap.get(key)
  //       const bucket = this.classify(action)
  //       if (bucket === 'earnLc' && points > 0) {
  //         row.totalLc = Number((row.totalLc + points).toFixed(6))
  //         row.actions[action] = Number(((row.actions[action] || 0) + points).toFixed(6))
  //       } else if (bucket === 'mevBought') {
  //         row.mevBought = Number((row.mevBought + mevQty).toFixed(6))
  //       } else if (bucket === 'mevSold') {
  //         row.mevSold = Number((row.mevSold + mevQty).toFixed(6))
  //       } else {
  //         // ignore for totals, but still keep numeric LC if you want later
  //       }
  //     })

  //     const rows = Array.from(userMap.values()).sort((a, b) => b.totalLc - a.totalLc)
  //     this.setState({ rows })
  //   } catch (e) {
  //     // ignore
  //     this.setState({ rows: [] })
  //   } finally {
  //     this.setState({ loading: false })
  //   }
  // }

loadData = async () => {

  const day = (this.state.date || '').trim()
  const dayTo = (this.state.dateTo || '').trim()
  const queryKey = `${day}|${dayTo}`

  if (this.lastQueryKey === queryKey && !this.state.loading && this.state.rows.length) {
    return
  }

  this.lastQueryKey = queryKey

  this.setState({ loading: true })

  try {

    const db = firebase.database
    let snap

    // Convert selected dates to timestamps
    const startTime = day ? new Date(`${day}T00:00:00`).getTime() : null
    const endTime = dayTo
      ? new Date(`${dayTo}T23:59:59`).getTime()
      : (day ? new Date(`${day}T23:59:59`).getTime() : null)

    if (day) {

      // Pull a broader set safely ordered by fdate
      snap = await db
        .ref('pointsTrail')
        .orderByChild('fdate')
        .startAt(`${day} 00:00`)
        .once('value')

    } else {

      snap = await db
        .ref('pointsTrail')
        .limitToLast(5000)
        .once('value')

    }

    const items = []

    if (snap.exists()) {

      snap.forEach((child) => {

        const val = child.val()

        if (!val || !val.fdate) return

        // Convert stored string to real timestamp
        const itemTime = new Date(val.fdate.replace(' ', 'T')).getTime()

        // Apply strict filtering in JS
        if (startTime && endTime) {
          if (itemTime < startTime || itemTime > endTime) return
        }

        items.push(val)

      })

    }

    const userMap = new Map()

    items.forEach((it) => {

      const userID = String(it.userID || '')
      if (!userID) return

      const fullName =
        [it.firstName, it.lastName]
          .filter(Boolean)
          .join(' ')
          .trim() || it.firstName || ''

      const action = String(it.actionType || 'Unknown')
      const points = this.parsePoints(it.pointsAdded)
      const mevQty = this.getMevQuantity(it, points)

      if (!userMap.has(userID)) {

        userMap.set(userID, {
          userID,
          fullName,
          totalLc: 0,
          actions: {},
          mevBought: 0,
          mevSold: 0
        })

      }

      const row = userMap.get(userID)
      const bucket = this.classify(action)

      if (bucket === 'earnLc' && points > 0) {

        row.totalLc = Number((row.totalLc + points).toFixed(6))
        row.actions[action] =
          Number(((row.actions[action] || 0) + points).toFixed(6))

      }

      else if (bucket === 'mevBought') {

        row.mevBought = Number((row.mevBought + mevQty).toFixed(6))

      }

      else if (bucket === 'mevSold') {

        row.mevSold = Number((row.mevSold + mevQty).toFixed(6))

      }

    })

    const rows =
      Array.from(userMap.values())
        .sort((a, b) => b.totalLc - a.totalLc)

    this.setState({ rows })

  } catch (e) {

    console.error(e)
    this.setState({ rows: [] })

  } finally {

    this.setState({ loading: false })

  }

}

  handleDateChange = (e) => {
    const v = String(e.target.value || '').slice(0, 10)
    this.setState({ date: v })
  }

  handleQueryChange = (e) => {
    this.setState({ query: e.target.value || '' })
  }

  render() {
    const { classes, userdata } = this.props

    if (!userdata || !IS_COMPANY_ADMIN[userdata.userType]) {
      return (
        <Paper className={classes.root}>
          <Typography variant='h6'>Access restricted</Typography>
          <Typography variant='body2'>Only admins can access LC Earnings Monitor.</Typography>
        </Paper>
      )
    }

    return (
      <Paper className={classes.root}>
        <Typography variant='h6'>LC Earnings Monitor</Typography>
        <div className={classes.controls}>
          <TextField
            label={isMobile ? '' : 'From (SAST)'}
            type='date'
            value={this.state.date}
            inputRef={this.dateInput}
            onChange={this.handleDateChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label={isMobile ? '' : 'To (SAST)'}
            type='date'
            value={this.state.dateTo}
            inputRef={this.dateToInput}
            onChange={(e) =>
              this.setState({ dateTo: String(e.target.value || '').slice(0, 10) })
            }
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label={isMobile ? '' : 'Filter by user name or ID'}
            type='text'
            value={this.state.query}
            onChange={this.handleQueryChange}
            placeholder={isMobile ? 'Name or UID' : 'e.g. John, 12345'}
            InputLabelProps={{ shrink: true }}
          />
          <Button variant='contained' color='primary' onClick={this.loadData} disabled={this.state.loading}>
            {this.state.loading ? 'Loading…' : 'Refresh'}
          </Button>
        </div>

        {isMobile ? (
          <div>
            {(() => {
              const baseRows = this.state.query
                ? this.state.rows.filter((r) => {
                    const q = this.state.query.toLowerCase().trim()
                    if (!q) return true
                    const name = String(r.fullName || '').toLowerCase()
                    const id = String(r.userID || '').toLowerCase()
                    return name.includes(q) || id.includes(q)
                  })
                : this.state.rows
              const totalPages = Math.max(1, Math.ceil(baseRows.length / this.state.pageSize))
              const page = Math.min(this.state.page, totalPages - 1)
              const paged = baseRows.slice(page * this.state.pageSize, (page + 1) * this.state.pageSize)
              return (
                <>
                  {paged.map((r) => {
                    const keys = Object.keys(r.actions || {})
                    const expanded = !!this.state.expanded[r.userID]
                    const shown = expanded ? keys : keys.slice(0, 10)
                    return (
                      <div className={classes.card} key={r.userID}>
                        <div className={classes.cardHeader}>
                          <div>
                            <div className={classes.userName}>{r.fullName || '(unknown)'}</div>
                            <div className={classes.userId}>{r.userID}</div>
                          </div>
                          <div className={classes.totalLc}>{r.totalLc.toFixed(3)} LC</div>
                        </div>
                        <div>
                          {shown.map((a) => (
                            <div key={a} className={classes.subcell}>
                              {a}: {Number(r.actions[a]).toFixed(3)} LC
                            </div>
                          ))}
                          {(r.mevBought > 0 || r.mevSold > 0) && (
                            <div className={classes.subcell}>
                              {r.mevBought > 0 ? `MEV bought: ${r.mevBought.toFixed(3)} • ` : ''}
                              {r.mevSold > 0 ? `MEV sold: ${r.mevSold.toFixed(3)}` : ''}
                            </div>
                          )}
                          {keys.length > shown.length && (
                            <Button
                              size='small'
                              color='primary'
                              onClick={() =>
                                this.setState((s) => ({ expanded: { ...s.expanded, [r.userID]: true } }))
                              }
                            >
                              Show more
                            </Button>
                          )}
                        </div>
                      </div>
                    )
                  })}
                  <div className={classes.pagerMobile}>
                    <Button
                      className={classes.pagerBtn}
                      variant='outlined'
                      size='small'
                      onClick={() => this.setState((s) => ({ page: Math.max(0, s.page - 1) }))}
                      disabled={page <= 0}
                    >
                      ‹
                    </Button>
                    <Typography variant='caption'>
                      Page {page + 1} of {totalPages}
                    </Typography>
                    <Button
                      className={classes.pagerBtn}
                      variant='outlined'
                      size='small'
                      onClick={() =>
                        this.setState((s) => ({
                          page: Math.min(totalPages - 1, s.page + 1)
                        }))
                      }
                      disabled={page >= totalPages - 1}
                    >
                      ›
                    </Button>
                  </div>
                </>
              )
            })()}
            {this.state.rows.length === 0 && !this.state.loading && (
              <Typography variant='body2'>No earnings found.</Typography>
            )}
          </div>
        ) : (
          <Table size='small' className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>User ID</TableCell>
                <TableCell align='right'>Total LC</TableCell>
                <TableCell>By Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
                const baseRows = this.state.query
                  ? this.state.rows.filter((r) => {
                      const q = this.state.query.toLowerCase().trim()
                      if (!q) return true
                      const name = String(r.fullName || '').toLowerCase()
                      const id = String(r.userID || '').toLowerCase()
                      return name.includes(q) || id.includes(q)
                    })
                  : this.state.rows
                const totalPages = Math.max(1, Math.ceil(baseRows.length / this.state.pageSize))
                const page = Math.min(this.state.page, totalPages - 1)
                const paged = baseRows.slice(page * this.state.pageSize, (page + 1) * this.state.pageSize)
                return (
                  <>
                    {paged.map((r) => {
                      const keys = Object.keys(r.actions || {})
                      const expanded = !!this.state.expanded[r.userID]
                      const shown = expanded ? keys : keys.slice(0, 10)
                      return (
                        <TableRow key={r.userID}>
                          <TableCell>{r.fullName || '(unknown)'}</TableCell>
                          <TableCell>{r.userID}</TableCell>
                          <TableCell align='right'>{r.totalLc.toFixed(3)}</TableCell>
                          <TableCell>
                            {shown.map((a) => (
                              <div key={a} className={classes.subcell}>
                                {a}: {Number(r.actions[a]).toFixed(3)} LC
                              </div>
                            ))}
                            {(r.mevBought > 0 || r.mevSold > 0) && (
                              <div className={classes.subcell}>
                                {r.mevBought > 0 ? `MEV bought: ${r.mevBought.toFixed(3)} • ` : ''}
                                {r.mevSold > 0 ? `MEV sold: ${r.mevSold.toFixed(3)}` : ''}
                              </div>
                            )}
                            {keys.length > shown.length && (
                              <Button
                                size='small'
                                color='primary'
                                onClick={() =>
                                  this.setState((s) => ({ expanded: { ...s.expanded, [r.userID]: true } }))
                                }
                              >
                                Show more
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Button
                            variant='outlined'
                            size='small'
                            onClick={() => this.setState((s) => ({ page: Math.max(0, s.page - 1) }))}
                            disabled={page <= 0}
                          >
                            Prev
                          </Button>
                          <Typography variant='caption'>
                            Page {page + 1} of {totalPages}
                          </Typography>
                          <Button
                            variant='outlined'
                            size='small'
                            onClick={() =>
                              this.setState((s) => ({
                                page: Math.min(totalPages - 1, s.page + 1)
                              }))
                            }
                            disabled={page >= totalPages - 1}
                          >
                            Next
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  </>
                )
              })()}
              {this.state.rows.length === 0 && !this.state.loading && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography variant='body2'>No earnings found.</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Paper>
    )
  }
}

LcEarningsMonitor.propTypes = {
  classes: PropTypes.object.isRequired,
  userdata: PropTypes.object
}

const mapStateToProps = (state) => ({
  userdata: state.userDialog.userDetails[0]
})

export default connect(mapStateToProps)(withStyles(styles)(LcEarningsMonitor))


